import { Spin } from "antd";
import DataNotFound from "../../common/DataNotFound";
import OrderViewGridFoodItem from "./OrderViewGridFoodItem";
import OrdersGridVariantsModal from "./OrdersGridVariantsModal";
import { useState } from "react";
import { isStockAvailable } from "../../../services/order-add-edit-service";

export default function OrderFoodsGrid({ foodList = [], selectedFood, addFoodInSelectedFoods }) {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [newSelectedFood, setNewSelectedFood] = useState({});

  const onClickFoodItem = (food) => {
    if (food.foodType === "SET_MENU") {
      addFoodInSelectedFoods(food, food.options[0].optionId);
      return;
    } else if (food.options.length === 1) {
      addFoodInSelectedFoods(food, food.options[0].optionId);
      return;
    }

    setNewSelectedFood(food);
    setIsModalOpen(true);
  };

  const handleOkVariantsModal = (selectedVariantId) => {
    addFoodInSelectedFoods(newSelectedFood, selectedVariantId);
    setIsModalOpen(false);
  };

  return (
    <section>
      <div className="w-full h-auto max-h-[480px] overflow-y-auto py-[23px] pl-[23px] pr-[5px] flex flex-wrap gap-[20px]">
        {foodList === null ? (
          <div className="h-[480px] w-full flex items-center justify-center">
            <Spin size="large" />
          </div>
        ) : foodList?.length > 0 ? (
          foodList?.map((food) => (
            <div
              key={food.id}
              className={`h-min-[130px] rounded-[8px] border border-[1px] ${
                selectedFood.id === food.id ? "border-[#FF0000]" : "border-[#FFD700]"
              } ${!isStockAvailable(food.id, food.options[0].optionId, 1, foodList) ? "bg-gray-200" : ""}`}
              onClick={() => onClickFoodItem(food)}
              style={{ width: "calc((100% - 80px) / 5)", minWidth: "120px" }} // 4 gaps x 20px = 80px
            >
              <OrderViewGridFoodItem food={food} />
            </div>
          ))
        ) : (
          <div className="flex items-center justify-center w-full h-[300px]">
            <DataNotFound message="No Food is available for this category" textSize={18} />
          </div>
        )}
      </div>
      <OrdersGridVariantsModal
        isOpen={isModalOpen}
        handleClose={() => setIsModalOpen(false)}
        handleCancel={() => setIsModalOpen(false)}
        handleOkVariantsModal={handleOkVariantsModal}
        variants={newSelectedFood.options || []}
      />
    </section>
  );
}
